import React from 'react';

import type * as PanelTypes from '../../../../state/views/panel/types';
import {type Ref as SectionRef} from '../../../../state/views/panelBankSectionConfig/types';
import {type MarimoConfig} from '../../../PanelMarimo/common';
import {PanelSettingsHeader} from '../components/PanelSettingsHeader';
import {SettingsContentWrapper} from '../components/SettingsContentWrapper';
import {
  MarimoSettingsStateContextProvider,
  useMarimoSettingsStateContext,
} from './MarimoSettingsContextProvider';
import {PanelTitle} from './PanelTitle';
import {SourceNotebook} from './SourceNotebook';

type Setting = {
  Component: React.FC;
  shouldShow?: (config: MarimoConfig) => boolean;
};

const SETTINGS: Setting[] = [
  {Component: SourceNotebook},
  {
    Component: PanelTitle,
    shouldShow: (config: MarimoConfig) => config.notebookId !== undefined,
  },
];

type MarimoSettingsProps = {
  panelRef: PanelTypes.Ref;
  panelBankSectionConfigRef: SectionRef;
};

const MarimoSettingsInternal = () => {
  const {config} = useMarimoSettingsStateContext();
  return (
    <div className="py-24 border-t border-wb-border flex flex-col gap-20">
      {SETTINGS.filter(
        ({shouldShow}) => shouldShow == null || shouldShow(config)
      ).map(({Component}, i) => (
        // oxlint-disable-next-line react/no-array-index-key -- https://oxc.rs/docs/guide/usage/linter/rules/react/no-array-index-key.html
        <Component key={i} />
      ))}
    </div>
  );
};

export const MarimoSettings = ({
  panelRef,
  panelBankSectionConfigRef,
}: MarimoSettingsProps) => {
  return (
    <MarimoSettingsStateContextProvider
      panelRef={panelRef}
      panelBankSectionConfigRef={panelBankSectionConfigRef}>
      <SettingsContentWrapper
        title="Marimo panel"
        header={<PanelSettingsHeader />}>
        <MarimoSettingsInternal />
      </SettingsContentWrapper>
    </MarimoSettingsStateContextProvider>
  );
};
